import { Popover, Tooltip } from 'bootstrap';

const configurePopoverSanitizer = () => {
  Tooltip.Default.allowList.input = ['id', 'type', 'name', 'checked'];
  Tooltip.Default.allowList.label = ['for'];
};

const initPopovers = () => {
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((trigger) => {
    const contentId = trigger.dataset.contentId;
    const content = contentId ? document.getElementById(contentId)?.innerHTML : undefined;

    if (content !== undefined) {
      Popover.getOrCreateInstance(trigger, { content, html: true });
    } else {
      Popover.getOrCreateInstance(trigger);
    }
  });
};

export const initGlobalBootstrapComponents = () => {
  configurePopoverSanitizer();
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((trigger) => Tooltip.getOrCreateInstance(trigger));
  initPopovers();
};
